module.exports = __webpack_public_path__ + "img/car_sendai23.5be60c1c.jpg";